export {
  getTtlBatchIntervalMs,
  getTtlPostMaxBatchSize,
  getTtlPostMs,
  getTtlUserMaxBatchSize,
  getTtlUserMs,
} from '@/libs/runtime-config/runtime-config';
